import { IProductDelivery, TShipmentDestinationPlace } from 'types/orders';
import { copyClipboard } from 'utils/copyClipboard';

/**
 * Acorta nombres de países largos para mejorar la visualización en la UI.
 * @param countryName - Nombre completo del país
 * @returns Nombre del país acortado si aplica, o el original
 */
export const getShortCountryName = (countryName?: string): string => {
  if (!countryName) return '';
  return countryName.replace('Estados Unidos de América', 'Estados Unidos');
};

/**
 * Genera el nombre a mostrar según el tipo de destino del envío.
 * @param destinationPlace - Tipo de destino ('user', 'nudos', 'office')
 * @param receiverName - Nombre del receptor (usado cuando es 'user')
 * @param countryName - Nombre del país de destino (usado para 'nudos' y 'office')
 * @returns Nombre formateado según el tipo de destino
 */
export const getDestinationDisplayName = (
  destinationPlace?: TShipmentDestinationPlace | string,
  receiverName?: string,
  countryName?: string
): string => {
  if (!destinationPlace) return 'Sin destino';

  const countryShortName = getShortCountryName(countryName);

  switch (destinationPlace as TShipmentDestinationPlace) {
    case 'user':
      return receiverName || 'Sin nombre';
    case 'nudos':
      return `Bodega ${countryShortName}`.trim();
    case 'office':
      return `Oficina ${countryShortName}`.trim();
    default:
      return 'Sin destino';
  }
};

/**
 * Agrupa los productos del envío por SKU.
 * @param products - Lista de productos del envío
 * @returns Objeto con SKU como clave y array de productos como valor
 */
export const groupProductsBySku = (products: IProductDelivery[]): Record<string, IProductDelivery[]> => {
  return products.reduce(
    (acc, product) => {
      const sku = product.sku || 'sin-sku';
      if (!acc[sku]) {
        acc[sku] = [];
      }
      acc[sku].push(product);
      return acc;
    },
    {} as Record<string, IProductDelivery[]>
  );
};

export const copyTextToClipboard = (text: string) => {
  copyClipboard({ text, notificationMessage: 'Copiado al portapapeles' });
};
